import { Header } from '@features/events';
import { ButtonPay, /*Term*/ } from '@features/events/event-buy';
import { EventInfo } from '@features/events/event-buy/information';
import { ArrowShortLeft } from '@shared/assets';
import { IconButton } from '@shared/ui';
import { Loader } from 'library/components/common';
import { useBuyTickets } from 'library/hooks/events';
import type { Event } from 'library/models/events';
import * as st from './styles.module.scss';

export const EventBuy = (): JSX.Element => {
  const buy = useBuyTickets();
  const eventInfo = buy.event.event as Event;
  const prepayCost = eventInfo.prepayment_cost;

  return (
    <>
      <Header
        title="Покупка билета"
        left={
          <IconButton variant="dark" onClick={buy.onClose}>
            <ArrowShortLeft />
          </IconButton>
        }
        right={<></>}
      />
      {buy.event.status === 'loaded' && buy.tickets.status === 'loaded' && (
        <section className={st.body}>
          <div className={st.info}>
            <EventInfo eventInfo={eventInfo} person={buy.user!} />
            {/* <div className={st.info__term}>
              <Term />
            </div> */}
            <div className={st.info__action}>
              <ButtonPay onClick={() => buy.onSubmit(prepayCost)} cost={eventInfo.cost} />
            </div>
          </div>
        </section>
      )}
      {buy.event.status === 'loading' && <Loader text="Загрузка..." />}
    </>
  );
};
